var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowRightLineBack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "65px",
    height: "63px",
    viewBox: "0 0 65 63",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "DCEBDEA1-C229-45FF-948F-774F7CBCF96E") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "zenvoya-JULY-2024",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "TRAVELER-INFO",
    transform: "translate(-66.000000, -298.000000)",
    fill: "#696969",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-25",
    transform: "translate(66.000000, 298.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "arrow-right-line-BACK",
    transform: "translate(32.500000, 31.500000) scale(-1, 1) translate(-32.500000, -31.500000) "
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "49.447125 27.450442 27.655875 5.72726905 33.4010625 0 65 31.500243 33.4010625 63 27.655875 57.2727715 49.447125 35.550044 0 35.550044 0 27.450442"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightLineBack);
export default __webpack_public_path__ + "static/media/arrow-right-line BACK.e42d8e7500297509ce4a101b94f9aca2.svg";
export { ForwardRef as ReactComponent };